<template>
  <div>
    <top-header :type="6" placeholder="手机号变更" fontSize="0.32rem" />
    <h3>验证手机号</h3>
    <van-form @submit="onSubmit">
      <div class="row m_flex_box flex_vc flex_jz">
        <p>{{old | capitalize}}</p>
        <van-button size="small" native-type="button" type="info" @click="sendCode" :disabled="codeTime < 120 ? true : false">{{ codeTime === 120 ? '发送验证码' : codeTime + '秒后重发' }}</van-button>
      </div>
      <van-field
        v-model="code"
        type="code"
        name="短信验证码"
        placeholder="短信验证码"
        :rules="[{ required: true, message: '请输入短信验证码' }]"
      />
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          验证
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";
export default {
  data() {
    return {
      old: '18151851890',
      code: '',
      codeTime: 120,
    };
  },
  components: {
    topHeader
  },
  filters: {
    capitalize (value) {
      if (!value) return ''
      value = value.toString()
      return value.substring(0,3)+"****"+value.substring(value.length-4)
    },
  },
  mounted() {
    this.old = this.$route.query.phone
  },
  methods: {
    testPhone(data) {
      return /^1[3456789]\d{9}$/.test(data);
    },
    sendCode() {
      if (this.codeTime === 120) {
        this.$http({
          url: 'cms/onlineUser/reg/getChangePhoneCode.do',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            phone: this.old,
          },
        }).then(res => {
          if(res.success) {
            this.$toast('验证码发送成功，请查收')
            this.codeTime -= 1
            let setTimer = setInterval(() => {
              if (this.codeTime > 0) {
                this.codeTime -= 1
              } else {
                this.codeTime = 120
                clearInterval(setTimer)
              }
            }, 1000);
          } else {
            this.$toast(res.msg)
          }
        })
      }
    },
    onSubmit(){
      this.$http.post('cms/onlineUser/reg/doChangePhoneCode.do', qs.stringify({
        code: this.code
      })).then(res => {
        if(res.success) {
          this.$router.push('/bindPhone')
        } else {
          this.$toast(res.msg)
        }
      })
    }
  },
};
</script>
<style lang="less" scoped>
h3{
  padding: 0 16px;
  font-size: 0.36rem;
  font-weight: 800;
  margin: 0.8rem 0 0.3rem;
}
.row{
  font-size: 14px;
  padding: 10px 16px;
}
</style>